import { DropdownFoldMenu } from '#/components/Dropdown/menus/Fold/DropdownFoldMenu';
import { useUser } from '#/contexts/UserEnvironmentContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { participateDropdownDataByLocale } from '#/mappings/ParticipateDropdown/participateDropdownDataByLocale';
import { isAdmin } from '#/utils/userEnvironment';

import {
  participateDropdownDataByResourcesItemType,
  participateDropdownDataBySearchItemType,
} from './ParticipateDropdownConstants';

type Props = {
  trackClickedContext: string;
};

export function ParticipateDropdownMenu({ trackClickedContext }: Props) {
  const { locale } = useI18n();
  const { user } = useUser();
  const isAdminUser = isAdmin(user);

  if (locale !== I18nLocale.ES) {
    return;
  }

  const { search, resources } = participateDropdownDataByLocale[locale];

  return (
    <DropdownFoldMenu
      left={{
        title: search.title,
        items: search.items.map((searchItem) => {
          const { iconName, qaId, trackClickedName } =
            participateDropdownDataBySearchItemType[searchItem.type];

          return {
            iconName,
            title: searchItem.title,
            href:
              isAdminUser && searchItem.adminUserHref
                ? searchItem.adminUserHref
                : searchItem.href,
            qaId,
            trackClicked: {
              name: trackClickedName,
              context: trackClickedContext,
            },
          };
        }),
      }}
      right={{
        title: resources.title,
        items: resources.items.map((resourceItem) => {
          const { image, imageHover, qaId, trackClickedName } =
            participateDropdownDataByResourcesItemType[resourceItem.type];

          return {
            image,
            imageHover,
            title: resourceItem.title,
            description: resourceItem.description,
            href: resourceItem.href,
            qaId,
            trackClicked: {
              name: trackClickedName,
              context: trackClickedContext,
            },
          };
        }),
      }}
    />
  );
}
